import { axiosWithAuth } from "../../helpers";

export const calculationService = {
	getCalculationList,
	calculate,
};

const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;
const PAGE_SIZE = 50;

function getCalculationList({ page, paidMonth, paidYear, filters, sortBy }) {
	const businessUnit =
		filters?.businessUnit?.parent?.name || filters?.businessUnit?.name;

	const businessUnitHierarchy =
		filters?.businessUnit?.parent && filters?.businessUnit?.name;

	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			source_type: filters?.sourceOfData?.name || null,
			agent_office: filters?.agentOffice || null,
			agent_name: filters?.agentName || null,
			partner_type: filters?.partnerType?.name || null,
			business_unit: businessUnit,
			business_unit_hierarchy: businessUnitHierarchy,
			mid: filters?.mid || null,
			merchant_name: filters?.merchantName || null,
			sort_type: sortBy?.id ? sortBy?.id : undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
		},
		url: `${RESIDUALS_API_URL}/api/calculation_data/${paidYear}/${paidMonth}`,
	};

	return axiosWithAuth(options);
}

function calculate({ paidYear, paidMonth, acceptMerchantChanges = false }) {
	const options = {
		method: "POST",
		params: {
			accept_merchant_changes: acceptMerchantChanges,
		},
		url: `${RESIDUALS_API_URL}/api/calculation_data/${paidYear}/${paidMonth}/calculate`,
	};

	return axiosWithAuth(options);
}
